import Cookie from 'js-cookie';

import { BAMBUS_COOKIE_NO_TRACK } from 'analytics/Config';

const cookie = Cookie.get(BAMBUS_COOKIE_NO_TRACK);

export const trackingAllowed = cookie !== undefined && cookie === 'false';
